// extracted by css-extract-rspack-plugin
export default {"search":"gdeIMt9PZzwOhUVE","searchLoading":"uEONyqgcuwnp_GP5","searchIcon":"b2c_7_M2PLQcJ3XD","searchInput":"P2PJpkcJ8Qo1d64f"};